// Ce qu'inclut une formule (élèves, rétention vidéo, support), affiché à l'identique
// dans les confirmations de passage à une formule supérieure et inférieure.

const clientsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    className="h-4 w-4 shrink-0 text-purple-400"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M64 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM0 464c0-97.2 78.8-176 176-176s176 78.8 176 176l0 6c0 23.2-18.8 42-42 42L42 512c-23.2 0-42-18.8-42-42l0-6zM432 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144 64.5 144 144l0 22.4c0 23-18.6 41.6-41.6 41.6l-144.8 0c6.6-12.5 10.4-26.8 10.4-42l0-6c0-51.5-17.4-98.9-46.5-136.7 22.6-14.7 49.6-23.3 78.5-23.3z" />
  </svg>
);

const videoRetentionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    className="h-4 w-4 shrink-0 text-purple-400"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M96 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L96 64zM464 336l73.5 58.8c4.2 3.4 9.4 5.2 14.8 5.2 13.1 0 23.7-10.6 23.7-23.7l0-240.6c0-13.1-10.6-23.7-23.7-23.7-5.4 0-10.6 1.8-14.8 5.2L464 176 464 336z" />
  </svg>
);

const supportPriorityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    className="h-4 w-4 shrink-0 text-purple-400"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M224 64c-79 0-144.7 57.3-157.7 132.7 9.3-3 19.3-4.7 29.7-4.7l16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0c-53 0-96-43-96-96l0-64C0 100.3 100.3 0 224 0S448 100.3 448 224l0 168.1c0 66.3-53.8 120-120.1 120l-87.9-.1-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 0 40 0c39.8 0 72-32.2 72-72l0-20.9c-14.1 8.2-30.5 12.8-48 12.8l-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l16 0c10.4 0 20.3 1.6 29.7 4.7-13-75.3-78.6-132.7-157.7-132.7z" />
  </svg>
);

// studentLimit null = unlimited (Scale). videoRetentionKey mirrors the plan lists.
export const makeBenefits = (t, studentLimit, videoRetentionKey) => [
  {
    customIcon: clientsIcon,
    text: studentLimit == null
      ? t('billing.benefit_clients_unlimited')
      : t('billing.benefit_clients', { limit: studentLimit }),
  },
  {
    customIcon: videoRetentionIcon,
    text: t('billing.benefit_video_retention', {
      duration: t(`billing.${videoRetentionKey || 'video_retention_6_months'}`),
    }),
  },
  { customIcon: supportPriorityIcon, text: t('billing.benefit_priority_support') },
];
